const THREE = require('three');

class Controls {

    constructor(object, domElement) {
        this.object = object;
        this.domElement = domElement;

        this.onMouseDown = this.onMouseDown.bind(this);
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);

        this.state = {
            dragging: false,
            currentX: 0,
            currentY: 0,
            prevX: 0,
            prevY: 0,
            deltaX: 0,
            deltaY: 0,
            sDeltaX: 0,
            sDeltaY: 0,
        };

        this.domElement.addEventListener('mousedown', this.onMouseDown);
        this.domElement.addEventListener('mousemove', this.onMouseMove);
        this.domElement.addEventListener('mouseup', this.onMouseUp);
        this.domElement.addEventListener('touchstart', this.onTouchStart);
        this.domElement.addEventListener('touchmove', this.onTouchMove);
        this.domElement.addEventListener('touchend', this.onTouchEnd);

        this.enabled = true;
        this.speed = Math.PI * 0.005;

        // this.movementSpeed = 1.0;
        // this.lookSpeed = 0.005;

        // this.lookVertical = true;
        // this.autoForward = false;

        // this.activeLook = true;

        // this.heightSpeed = false;
        // this.heightCoef = 1.0;
        // this.heightMin = 0.0;
        // this.heightMax = 1.0;

        // this.constrainVertical = false;
        // this.verticalMin = 0;
        // this.verticalMax = Math.PI;

        // this.mouseDragOn = true;

        // this.autoSpeedFactor = 0.0;

        // this.mouseX = 0;
        // this.mouseY = 0;

        // this.moveForward = false;
        // this.moveBackward = false;
        // this.moveLeft = false;
        // this.moveRight = false;

        // this.viewHalfX = 0;
        // this.viewHalfY = 0;

        // // private variables

        // var lat = 0;
        // var lon = 0;

        // var lookDirection = new THREE.Vector3();
        // var spherical = new THREE.Spherical();
        // var target = new THREE.Vector3();

        // if (this.domElement !== document) {
        //     this.domElement.setAttribute('tabindex', - 1);
        // }
    }

    dragging() {
        return this.state.dragging;
    }

    onMouseDown(event) {
        let startX = event.clientX;
        let startY = event.clientY;

        this.onPointerDown(startX, startY);
    }

    onTouchStart(event) {
        if (event.touches && event.touches.length > 0) {
            this.onPointerDown(event.touches[0].clientX, event.touches[0].clientY);
        }
    }

    onPointerDown(startX, startY) {
        this.state.dragging = true;
        this.state.prevX = startX;
        this.state.prevY = startY;
        this.state.currentX = startX;
        this.state.currentY = startY;
    }

    onMouseUp() {
        this.onPointerUp();
    }

    onTouchEnd() {
        this.onPointerUp();
    }

    onPointerUp() {
        this.state.dragging = false;
    }

    onMouseMove(event) {
        this.onPointerMove(event.clientX, event.clientY);
    }

    onTouchMove(event) {
        if (event.touches && event.touches.length > 0) {
            this.onPointerMove(event.touches[0].clientX, event.touches[0].clientY);
        }
    }

    onPointerMove(currentX, currentY) {
        if (this.state.dragging) {
            this.state.currentX = currentX;
            this.state.currentY = currentY;
        }
    }

    update(deltaTime) {
        let ratioTime = deltaTime / 16.67; // 1 / 60;
        // x
        this.state.deltaX = this.state.currentX - this.state.prevX;
        this.state.sDeltaX += (this.state.deltaX - this.state.sDeltaX) * 0.05 * ratioTime;
        this.state.prevX = this.state.currentX;

        // y
        this.state.deltaY = this.state.currentY - this.state.prevY;
        this.state.sDeltaY += (this.state.deltaY - this.state.sDeltaY) * 0.05 * ratioTime;
        this.state.prevY = this.state.currentY;

        this.object.rotation.y += this.state.sDeltaX * this.speed;
    }

    dispose() {
        this.domElement.removeEventListener('mousedown', this.onMouseDown);
        this.domElement.removeEventListener('mousemove', this.onMouseMove);
        this.domElement.removeEventListener('mouseup', this.onMouseUp);
        this.domElement.removeEventListener('touchstart', this.onTouchStart);
        this.domElement.removeEventListener('touchmove', this.onTouchMove);
        this.domElement.removeEventListener('touchend', this.onTouchEnd);

        this.onMouseDown = null;
        this.onMouseUp = null;
        this.onTouchStart = null;
        this.onTouchEnd = null;
        this.onMouseMove = null;
        this.onTouchMove = null;
    }

}

export default Controls;